<template>
    <div id="applicant-rep-legal-ids" class="mt-base">
        <div class="vx-row">
            <div class="vx-col w-full">
                <h2>{{ currentTitle.title }}</h2>
                <p>{{ currentTitle.subtitle }}</p>
                <vs-divider></vs-divider>
            </div>
            <!-- INFORMACIÓN SOBRE EL RFC Y CURP -->
            <div>
                <div class="vx-row ml-2">
                    <div class="vx-col sm:w-full md:w-8/12 lg:w-8/12">
                        <div class="vx-row">
                            <div class="vx-col w-full mb-base mt-2">
                                <vs-input
                                    @input="(val) => (rfc = rfc.toUpperCase())"
                                    class="w-full"
                                    label="RFC *"
                                    name="rfc"
                                    v-validate="requiredRules"
                                    v-model.lazy="rfc"
                                    :danger="hasError('rfc')"
                                    :danger-text="errorText('rfc')"
                                    :success="isSuccess('rfc')"
                                    icon-pack="feather"
                                    :placeholder="requiredPlaceholder"
                                />
                                <a
                                    class="inline-link-primary"
                                    target="_blank"
                                    rel="noopener"
                                    :href="$sanitizeUrl(rfcUrl)"
                                    >Consultar mi RFC</a
                                > 
                            </div>
                            <div class="vx-col w-full">
                                <vs-input
                                    @input="(val) => (curp = curp.toUpperCase())"
                                    class="w-full"
                                    label="CURP *"
                                    name="curp"
                                    v-validate="requiredRules"
                                    v-model.lazy="curp"
                                    :danger="hasError('curp')"
                                    :danger-text="errorText('curp')"
                                    :success="isSuccess('curp')"
                                    icon-pack="feather"
                                    :placeholder="requiredPlaceholder"
                                />
                                <a
                                    class="inline-link-primary"
                                    target="_blank"
                                    rel="noopener"
                                    :href="$sanitizeUrl(curpUrl)"
                                    >Consultar mi CURP</a
                                >
                            </div>
                        </div>
                        <vs-alert
                            v-if="errorMssg"
                            icon-pack="feather"
                            icon="icon-alert-triangle"
                            class="mb-5 mt-5"
                            color="danger">
                            <span class="font-regular">{{ errorMssg }}</span>
                        </vs-alert>
                    </div>
                </div>
            </div>
        </div>
        <div class="justify-end vx-row">
            <!-- <div class="vx-col md:w-1/2 sm:w-full w-full">
                <vs-button class="w-full mt-4" type="border" color="dark" @click="isMainOnboardingStepVisible = false"
                    >Atrás</vs-button>
            </div> -->
            <div class="lg:w-1/10 lg:w-1/6 md:w-1/4 sm:w-1/2 vx-col w-full">
                <vs-button id="3_name_confirm_btn" class="w-full mt-4" color="dark" @click="savePersonalIds">Continuar</vs-button>
            </div>
        </div>

        <role-integration-by-curp 
            v-if="showCurpMatchPopup"
            ref="RoleIntegrationByCurp"
            :matched-data="curpMatchedData" 
            :current-role="'Solicitante'"
            :model-to-update="UserId"
            :is-business="true"
            :is-new-user="false"
        />
    </div>
</template>

<script>
import ApplicantOnboardingAddress from '../../../onboarding/components/business/ApplicantOnboardingAddress.vue';
import CreditScoreRequest from '../../../../../components/profile_shared/CreditScoreRequest.vue';

import inputHelper from "@mixins/inputHelper";
import formatHelper from "@mixins/formatHelper";
import formHelper from '@components/mixins/formHelper';
import RoleIntegrationByCurp from '../../../../register/components/RoleIntegrationByCurp.vue';

const LOAN_TYPE_ECOTECNOLOGIAS = 1;
const LOAN_TYPE_PERSONAL = 5;
const LOAN_TYPE_PYME = 4;   

const addressOptions = [
    { label: "Sí, es la misma dirección", value: "1", desc: null },
    { label: "No, son diferentes", value: "2", desc: null },
];

export default {
    name: "ApplicantRepLegalIds",
    props: ["onboardingStepData", "isMoral"],
    mixins: [inputHelper, formatHelper, formHelper],
    components: {
        ApplicantOnboardingAddress,
        CreditScoreRequest,
        RoleIntegrationByCurp
    },
    data: () => ({
        isEdit: false,
        addressOptions: addressOptions,
        errorMssg: null,
        sameAddress: "1",
        requiredRules: "required",
        requiredPlaceholder: "(Requerido)",
        rfcUrl: "https://www.sat.gob.mx/aplicacion/operacion/31274/consulta-tu-clave-de-rfc-mediante-curp",
        curpUrl: "https://www.gob.mx/curp/",
        rfc: null,
        curp: null,
        isMounted: false,
        showCurpMatchPopup: false,
        curpMatchedData: {}

    }),
    computed: {
        base() {
            return this.onboardingStepData;
        },
        finance() {
            return this.base.finance;
        },
        hasOffer() {
            return this.base.loan_proposal_timestamp != null && this.base.finance.credit_acceptance_date == null;
        },
        current_step() {
            return this.onboardingStepData.loan_request_step;
        },
        business_personal() {
            return this.onboardingStepData.client.user.business.personal;
        },
        business_address() {
            return this.onboardingStepData.client.user.business.address;
        },
        business_personal_address() {
            return this.onboardingStepData.client.user.business.personal.address;
        },
        currentTitle() {
            let title = {
                title : "",
                subtitle : ""
            };

            switch(this.current_step) {
                case "pm_2_business_address_confirmation":
                    title.title = "Información personal";
                    title.subtitle = "Confirma la información de tu domicilio";
                    break;
                case "pm_3_personal_profile_address":
                    title.title = "Valida tu RFC y CURP";
                    title.subtitle = "Valida tus datos";
                    break;
                case "pm_4_personal_profile_curp":
                    title.title = "Autorización de consulta de Buró de Crédito";
                    title.subtitle = `RFC: ${this.business_personal.rfc}`;
                    break;
                case "pm_5_personal_profile_sic_check":
                    title.title = "Estamos preparando tu oferta";
                    title.subtitle = `En unos minutos te compartiremos el resultado.`;
                    break;

                    default: 
                        title.title = "Información personal";
                        title.subtitle = "Ya nos haz proporcionado la información necesaria para tu solicitud de crédito.";
                    break;
            }

            return title;
        },
        loanType() {
            const loanType = this.base.finance.loan_type;
            let loanTypeText = "";
            if(loanType === LOAN_TYPE_ECOTECNOLOGIAS) {
                loanTypeText = "Ecotecnologías";
            } else if(loanType === LOAN_TYPE_PERSONAL) {
                loanTypeText = "Personal";
            } else if(loanType === LOAN_TYPE_PYME) {
                loanTypeText = "PYME";
            }

            return loanTypeText;
        },
    },
    beforeMount() {
        if (this.business_address.id != this.business_personal_address.id && this.business_personal_address.neighborhood_id != null) {
            this.sameAddress = "2";
        } else {
            this.isEdit = true;
        }

        this.rfc = this.business_personal.rfc;
        this.curp = this.business_personal.curp;

        this.isMounted = true;
    },
    mounted() {
        if (this.current_step == "pm_5_personal_profile_sic_check" && !this.hasOffer) {
            // this.offerIsNotReadyNotif();
        }
    },
    methods: {
        async getProjectData() {

            if(this.current_step == "pm_4_personal_profile_curp") {
                await axios.put(
                    `/api/loan-onboarding/put/${this.base.id}/update-sic-check`, {
                        project_id: this.base.id,
                    }
                );
                // this.offerIsNotReadyNotif();
            }
            this.isEdit = false;
            this.$emit('updated', 1);
        },
        async savePersonalIds() {
            this.errorMssg = null;
            if (!(await this.validateForm())) {
                return false;
            }
            let validRfc = this.isValidRfcFormatByPersonType(this.rfc, false);
            if(!validRfc){
                this.errorMssg = "La estructura de la clave RFC es incorrecta."
                return false;
            }
            let validCurp = this.isValidCurpFormat(this.curp);
            if(!validCurp){
                this.errorMssg = "La estructura de la clave CURP es incorrecta."
                return false;
            }
            let uniqueCurp = await this.validate_unique_curp(this.curp, this.business_personal.id);
            if(!uniqueCurp){
                console.log("CURP no único, notificando al equipo...");
                this.sendIdentifiersNotification(
                    {
                        user_id: this.base.client.user.id,
                        loan_id: this.base.id,
                        role: "loan",
                        flow: "CURP",
                        id: this.curp
                    }
                );

                // Busca el curp para obtener el usuario asociado y su correo
                let curpMatchedData = await this.verify_curp_matches(this.curp, this.business_personal.id);
                this.curpMatchedData = curpMatchedData;
                this.showCurpMatchPopup = true;

                this.$nextTick(() => {
                    this.$refs.RoleIntegrationByCurp.checkFlow();
                });
                return;
            }
            this.showLoading(true);
            try {
                let payload = {
                    applicant_id: this.ApplicantId,
                    project_id: this.base.id,
                    rfc: this.rfc,
                    curp: this.curp,
                };
                const res = await axios.put(
                    `/api/loan-onboarding/put/${this.ApplicantId}/update-bp-ids`,
                    payload
                );

                if(res.data == "success") {
                    this.$emit("updated", 1);
                    this.showLoading(false);
                    return true;
                } else {
                    this.showLoading(false);
                    this.errorMssg = res.data;
                    return false;
                }
            } catch (e) {
                this.showLoading(false);
                console.log(e);
                this.errorMssg = "Ocurrió un error al guardar los datos.";
            }
        },
        async validateForm() {
            this.errorMssg = null;
            return this.$validator.validateAll();
        },
        hasError(val) {
            return this.errors.has(val);
        },
        errorText(val) {
            return this.errors.first(val);
        },
        isSuccess(val) {
        let ff = this.fields[val];
            return ff && ff.required && ff.valid;
        },
        offerIsNotReadyNotif() {
            this.$vs.dialog({
                color: 'black',
                title: 'Estamos preparando tu oferta',
                text: `En unos minutos te compartiremos el resultado.`,
                acceptText: "Notificarme cuando esté lista",
                cancelText: '',
                accept: this.goToHomePage,
                cancel: this.goToHomePage
            });
        },
        async goToHomePage(){
            await this.$router.push({name: 'inicioSolicitante'});
        },
    }
}
</script>

<style>

.address-card {
    border-radius: 8px;
    border: 1px solid #28DE18;
    padding: 1rem;
    width: fit-content;
}

.vs-button.small:not(.includeIconOnly) {
    padding: 1px
}
</style>